<div class="d-flex justify-content-center align-items-center h-100 gap-2">
  <button type="button" class="btn btn-sm btn-outline-secondary border-0 p-1 action-btn"
    (click)="onToggleColumnSelector($event)" title="Spalten verwalten">
    <i class="icon-plus" style="font-size: 14px;"></i>
  </button>
  <button type="button" class="btn btn-sm btn-outline-secondary border-0 p-1 action-btn"
    (click)="onResetColumns($event)" title="Standard-Layout wiederherstellen">
    <i class="icon-refresh" style="font-size: 14px;"></i>
  </button>
</div>